import { useTranslation } from "react-i18next";
import type { StripeInvoicesBlock as StripeInvoicesBlockType } from "../../../../shared/schema";
import { MobileList } from "../../MobileList";
import { useStripeInvoices } from "../../../hooks/useStripeInvoices";
import { InvoiceCard } from "./InvoiceCard";
import { InvoiceListSkeleton } from "./InvoiceListSkeleton";

interface StripeInvoicesBlockProps {
  block: StripeInvoicesBlockType;
}

export const StripeInvoicesBlock = ({ block }: StripeInvoicesBlockProps) => {
  const { t } = useTranslation("payments");

  const { invoices, isLoading, error } = useStripeInvoices();

  if (isLoading) {
    return <InvoiceListSkeleton count={block.props.maxItems ?? 5} />;
  }

  if (error) {
    console.error("Failed to load Stripe invoices:", error);
  }

  return (
    <MobileList
      items={invoices}
      renderItem={(invoice) => <InvoiceCard invoice={invoice} />}
      title={t("Your Invoices")}
      maxItems={block.props.maxItems ?? 5}
      emptyMessage={block.props.emptyMessage ?? t("No invoices")}
    />
  );
};
